import React from "react";
import "./styles/outlets.css";

const Outlet = () => {
  const outlets = [
    {
      name: "Vijay Nagar",
      contact: "+91 9926540204",
      time: "8:00 AM - 10:00 PM",
      mapLink:
        "https://www.google.co.in/maps/place/New+Ganesh+Bakers/@22.7016347,75.7912541,13z/data=!4m10!1m2!2m1!1sganesh+bakery+vijay+nagar!3m6!1s0x396303e719bcb6ed:0xcbc3cc65d5954247!8m2!3d22.7524021!4d75.8955852!15sChlnYW5lc2ggYmFrZXJ5IHZpamF5IG5hZ2FyWhsiGWdhbmVzaCBiYWtlcnkgdmlqYXkgbmFnYXKSAQZiYWtlcnngAQA!16s%2Fg%2F11x094d7c2?entry=ttu&g_ep=EgoyMDI1MDMwNC4wIKXMDSoASAFQAw%3D%3D",
    },
    {
      name: "Sindhi Colony",
      contact: "+91 9826073169",
      time: "8:00 AM - 10:00 PM",
      mapLink: "https://maps.app.goo.gl/cM2BmyXpMEWFvaQ2A",
    },
    {
      name: "Khandwa Road",
      contact: "+91 7389763300",
      time: "8:00 AM - 10:00 PM",
      mapLink:
        "https://www.google.co.in/maps/place/New+Ganesh+Bakers/@22.7016347,75.7912541,13z/data=!4m10!1m2!2m1!1sganesh+bakery+vijay+nagar!3m6!1s0x3962fd82aaa8291d:0x7cd1e2ef5e50f70f!8m2!3d22.6688663!4d75.8815424!15sChlnYW5lc2ggYmFrZXJ5IHZpamF5IG5hZ2FyWhsiGWdhbmVzaCBiYWtlcnkgdmlqYXkgbmFnYXKSAQZiYWtlcnngAQA!16s%2Fg%2F11s2r7jwbm?entry=ttu&g_ep=EgoyMDI1MDMwNC4wIKXMDSoASAFQAw%3D%3D",
    },
    {
      name: "Sarvoday Nagar",
      contact: "+91 9926540204",
      time: "8:00 AM - 10:00 PM",
      mapLink:
        "https://www.google.co.in/maps/place/New+Ganesh+Bakers/@22.7016558,75.7912542,13z/data=!4m10!1m2!2m1!1sganesh+bakery+vijay+nagar!3m6!1s0x3962fde955131d21:0x6b7b8e3e0fc98105!8m2!3d22.7016558!4d75.8674719!15sChlnYW5lc2ggYmFrZXJ5IHZpamF5IG5hZ2FyWhsiGWdhbmVzaCBiYWtlcnkgdmlqYXkgbmFnYXKSAQZiYWtlcnngAQA!16s%2Fg%2F11gm70xz0y?entry=ttu&g_ep=EgoyMDI1MDMwNC4wIKXMDSoASAFQAw%3D%3D",
    },
  ];

  return (
    <div className="outlet-container">
      <h1 className="outlet-title">Visit Our Outlets</h1>
      <p className="outlet-description">
        We are conveniently located across Indore. Visit us at any of our
        locations for a delicious experience.
      </p>

      <div className="outlet-list">
        {outlets.map((outlet, index) => (
          <div className="outlet-card" key={index}>
            <h2>{outlet.name}</h2>
            <p>
              <strong>Contact:</strong>{" "}
              <a href={`tel:${outlet.contact}`}>{outlet.contact}</a>
            </p>
            <p>
              <strong>Timings:</strong> {outlet.time}
            </p>
            <a
              className="map-btn"
              href={outlet.mapLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Directions
            </a>
          </div>
        ))}
      </div>

      <div className="map-section">
        <h2>Our Location</h2>
        <iframe
          title="Google Map"
          src="https://maps.google.com/maps?q=New%20Ganesh%20Bakers%20Indore&t=&z=13&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="400"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen=""
        ></iframe>
      </div>
    </div>
  );
};

export default Outlet;
